/** 登录卡片里「&」分隔线：两侧细线 + 中间 &，海外首屏与国内单步登录共用。 */
export const LoginSeparator = () => (
  <div className="flex w-full items-center py-1 text-sm text-system-white40 before:mr-2 before:h-[1px] before:w-1/2 before:bg-white/[0.14] after:ml-2 after:h-[1px] after:w-1/2 after:bg-white/[0.14] lg:text-xs">
    <span className="px-2 leading-4">&</span>
  </div>
);
